// extracted by mini-css-extract-plugin
export default {"client-link":"KycApplicationPage_client-link__hqCnQ"};